import { Event, EventStatus, GeneralEventFrontEndClientSettings } from '../Types/event';

export function isEventRecruitingSubstitutes(
	event: Pick<Event, 'Status' | 'IsAllowedToHandleEvent' | 'MissingOrganizerCount' | 'SubstituteRecruitmentReleased'>,
	settings: GeneralEventFrontEndClientSettings | undefined
) {
	return (
		settings?.AllowSelfAddSubstituteCoOrganizers === true &&
		event.IsAllowedToHandleEvent &&
		event.Status === EventStatus.Upcoming &&
		event.MissingOrganizerCount > 0 &&
		(!settings.ManualEventSubstituteRelease || event.SubstituteRecruitmentReleased === true)
	);
}
